import React from 'react';
import { formatEuro, formatNumber } from '../../../utils/formatters';

/**
 * Footer CTA verde "Passa a Energy.Lab..." + data generazione.
 * @param {Object} props
 * @param {Object} props.analysis - analisi corrente
 */
export const AnalysisFooter = ({ analysis }) => {
  const annualPositive = analysis.annual_projection?.is_positive;
  const hasAnnual = !!analysis.annual_projection;
  const showPositive = hasAnnual ? annualPositive : analysis.is_positive;

  return (
    <>
      {showPositive && (
        <div className="text-white" style={{ backgroundColor: '#4CAF50', padding: '18px 24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <p style={{ fontSize: '16px', fontWeight: '600', letterSpacing: '0.02em', margin: 0, padding: 0, textAlign: 'center', lineHeight: '1.2' }}>
            Passa a Energy.Lab e risparmia {formatEuro(Math.abs(analysis.annual_projection?.savings_annual || analysis.savings_amount || 0))}/anno ({formatNumber(Math.abs(analysis.annual_projection?.savings_annual_percent || analysis.savings_percent || 0), 1)}%)
          </p>
        </div>
      )}

      <div style={{ padding: '6px 20px', textAlign: 'right' }}>
        <span style={{ fontSize: '10px', color: '#8A9B8A' }}>
          Generato il {new Date().toLocaleDateString('it-IT')}
        </span>
      </div>
    </>
  );
};
